import { IconButton } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import { toast } from "react-toastify";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";

const LinkItem = ({ title, link, value, setServicioData, handleSaveLink }) => {

  return (
    <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
        
      {/* Título */}
      <div className="w-[30%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
        <span className="text-xs font-medium text-gray-700 break-words">
          {title}
        </span>
      </div>
    
      {/* URL */}
      <div className="w-[60%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
        <input
          value={value}
          onChange={(e) =>{
            setServicioData((prev) => ({
              ...prev,
              [link]: e.target.value,
            }))
          }}
          className="text-xs w-full text-blue-600 underline py-2 hover:text-blue-800"
        />
      </div>
      
      {/* Save */}
      <div className="w-[10%] flex justify-center items-center px-2 py-2">
        <IconButton 
          aria-label="delete" 
          size="small" 
          color="success"
          onClick={() => handleSaveLink(link, value)}
        >
          <SaveIcon fontSize="inherit" />
        </IconButton>
      </div>
    </div>
  )
} 

const SeguimientoLinks = ({ setServicioData, servicioData }) => {

  const serviceId = servicioData.id
  const category = servicioData.servicio.categoria

  const handleSaveLink = async (link, value) => {
    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`, {
        [link]: value
      })
      toast.success("Link actualizado correctamente")
    } catch (error) {
      toast.error("Error al actualizar el link")
    }
  }

  const CategoriesLinks = [
    { category: "Software", 
      links: [
        { title: "GitHub", link: "linkGithub" },
        { title: "Flujo", link: "linkFlujo" },
        { title: "Roadmap", link: "linkRoadmap" },
        { title: "Esquema Base de Datos", link: "linkEsquemaBaseDatos" },
        { title: "Manual de uso", link: "linkManualUso" },
        { title: "Capacitacion", link: "linkCapacitacion" }
      ] 
    },
    { category: "Web", 
      links: [
      { title: "Diseño gráfico", link: "linkDisenioGrafico" }
    ] },
    { category: "UI/UX", 
      links: [
        { title: "Figma", link: "linkFigma" },
        { title: "Diseño gráfico", link: "linkDisenioGrafico" }
      ] 
    },
    { category: "SEO", 
      links: [
        { title: "Recursos", link: "linkRecursos" },
        { title: "Investigación", link: "linkInvestigacion" },
        { title: "Reporte inicial", link: "linkReporteInicial" },
        { title: "Reporte final", link: "linkReporteFinal" }
      ] 
    },
    { category: "ADS", 
      links: [
        { title: "Plan de trabajo", link: "linkPlanTrabajo" },
        { title: "Recursos", link: "linkRecursos" },
        { title: "Diseño gráfico", link: "linkDisenioGrafico" },
        { title: "Audiovisuales", link: "linkAudiovisuales" },
        { title: "Informes", link: "linkInformes" }
      ] 
    },
    { category: "SMM", 
      links: [
        { title: "Plan de trabajo", link: "linkPlanTrabajo" },
        { title: "Recursos", link: "linkRecursos" },
        { title: "Diseño gráfico", link: "linkDisenioGrafico" },
        { title: "Audiovisuales", link: "linkAudiovisuales" },
        { title: "Parrilla de contenido", link: "linkParrillaContenido" }
      ] 
    },
    { category: "Audiovisuales", 
      links: [
        { title: "Plan de trabajo", link: "linkPlanTrabajo" },
        { title: "Recursos", link: "linkRecursos" },
        { title: "Audiovisual borrador", link: "linkAudiovisualBorrador" },
        { title: "Audiovisual terminado", link: "linkAudiovisualTerminado" }
      ] 
    },
    { category: "Branding", 
      links: [
        { title: "Diseño gráfico", link: "linkDisenioGrafico" },
        { title: "Recursos", link: "linkRecursos" },
        { title: "Audiovisual borrador", link: "linkAudiovisualBorrador" },
        { title: "Audiovisual terminado", link: "linkAudiovisualTerminado" }
      ] 
    },
    { category: "SaaS",
      links: [
        { title: "Link oficial", link: "linkOficial" },
        { title: "Flujo", link: "linkFlujo" },
        { title: "Manual de uso", link: "linkManualUso" },
        { title: "Capacitacion", link: "linkCapacitacion" }
      ] 
    }
  ]

  const normalizedCategory = (category || "").toLowerCase()
  const categoryConfig = CategoriesLinks.find(cfg => {
    const cfgCat = cfg.category.toLowerCase()
    return cfgCat === normalizedCategory || (cfgCat === "audiovisuales" && normalizedCategory === "audiovisual")
  })

  return (
    <div className="flex flex-col gap-2">

      {/* Cuenta correo */}
      {/* <LinkItem 
        title="Cuenta correo cliente" 
        link="cuentaCorreo" 
        value={servicioData.cuentaCorreo || ""} 
        setServicioData={setServicioData} 
        handleSaveLink={handleSaveLink}
      /> */}

      {(categoryConfig?.links || []).map(({ title, link }) => (
        <LinkItem
          key={link}
          title={title}
          link={link}
          value={servicioData[link] || ""}
          setServicioData={setServicioData}
          handleSaveLink={handleSaveLink}
        />
      ))}

    </div>
  )
}

export default SeguimientoLinks;